var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-btn',{staticClass:"multi-text-color",attrs:{"pill":"","variant":_vm.getStatusHelper(),"href":_vm.nereus_url,"target":"_blank"}},[(_vm.iconValue)?_c('i',{staticClass:"material-icons multi-icon-color"},[_vm._v(_vm._s(_vm.getStatusIndicatorIcon())+"\n    ")]):_vm._e(),_vm._v("\n    "+_vm._s(_vm.getStatusIndicatorText())+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }